import * as React from 'react';
import styles from './index.less';
// import FResourceList, { FResourceListProps } from '@/components/FResourceList';
import FDropdownMenu from '@/components/FDropdownMenu';
import FComponentsLib from '@freelog/components-lib';
import * as AHooks from 'ahooks';
import { FServiceAPI, FUtil } from '@freelog/tools-lib';
import FIcons from '@/components/FIcons';
import FListFooter, { listStateAndListMore } from '@/components/FListFooter';
import FLoadingTip from '@/components/FLoadingTip';
import FNoDataTip from '@/components/FNoDataTip';

// import FCoverImage from '@/components/FCoverImage';

interface FObjectSelectorProps {
  // disabledIDsOrNames?: string[];
  // showRemoveIDsOrNames?: string[];
  selectedObjectIDs: string[];

  onSelect?({ id, name }: { id: string; name: string; }): void;

  onDelete?({ id, name }: { id: string; name: string; }): void;
}

interface FObjectSelectorStates {
  selectOptions: { text: string, value: string }[];

  objectList: {
    objectId: string;
    bucketName: string;
    objectName: string;
    resourceType: string[];
    updateDate: string;
  }[];
  oTotal: number;
  oSelect: '_all' | string;
  oInput: string;
}

const initStates: FObjectSelectorStates = {
  selectOptions: [{ text: '全部Bucket', value: '_all' }],
  objectList: [],
  oTotal: -1,
  oSelect: '_all',
  oInput: '',
};

function FObjectSelector({
                           // disabledIDsOrNames,
                           // showRemoveIDsOrNames,
                           selectedObjectIDs,
                           onSelect,
                           onDelete,
                         }: FObjectSelectorProps) {

  const [$state, $setState] = AHooks.useSetState<FObjectSelectorStates>(initStates);

  const [$showDeleteResourceID, set$showDeleteResourceID, get$showDeleteResourceID] = FUtil.Hook.useGetState<string>('');

  const [$listState, set$listState, get$listState] = FUtil.Hook.useGetState<'loading' | 'noData' | 'noSearchResult' | 'loaded'>('loading');
  const [$listMore, set$listMore, get$listMore] = FUtil.Hook.useGetState<'loading' | 'andMore' | 'noMore'>('loading');

  AHooks.useMount(async () => {
    fetchObjects(true);

    const params: Parameters<typeof FServiceAPI.Storage.bucketList>[0] = {
      // bucketType: 0,
      bucketType: 1,
    };
    const { data }: {
      data: any[];
    } = await FServiceAPI.Storage.bucketList(params);

    $setState({
      selectOptions: [
        ...$state.selectOptions,
        ...data.map((b) => {
          return {
            value: b.bucketName,
            text: b.bucketName,
          };
        }),
      ],
    });
  });

  AHooks.useUnmount(() => {

  });

  // AHooks.useDebounceEffect(() => {
  //   fetchObjects(true);
  // }, [$state.oInput, $state.oSelect], {
  //   wait: 300,
  // });

  const { run } = AHooks.useDebounceFn(() => {
    fetchObjects(true);
  }, {
    wait: 300,
  });

  async function fetchObjects(restart: boolean) {
    let objectListData: FObjectSelectorStates['objectList'] = [];

    if (!restart) {
      objectListData = $state.objectList;
      set$listMore('loading');
    } else {
      set$listState('loading');
    }

    const params: Parameters<typeof FServiceAPI.Storage.objectList>[0] = {
      bucketName: $state.oSelect,
      isLoadingTypeless: 1,
      keywords: $state.oInput,
      skip: objectListData.length,
      limit: FUtil.Predefined.pageSize,
      // extNames: ''
    };
    const { data } = await FServiceAPI.Storage.objectList(params);

    const objectList = [
      ...objectListData,
      ...data.dataList.map((o: any) => ({
        objectId: o.objectId,
        bucketName: o.bucketName,
        objectName: o.objectName,
        resourceType: o.resourceType,
        updateDate: FUtil.Format.formatDateTime(o.updateDate, true),
      })),
    ];

    const { state, more } = listStateAndListMore({
      list_Length: objectList.length,
      total_Length: data.totalItem,
      has_FilterCriteria: $state.oInput !== '',
    });

    set$listState(state);
    set$listMore(more);

    $setState({
      oTotal: data.totalItem,
      objectList,
    });
  }

  return (<>
    <div className={styles.filter}>
      <FDropdownMenu
        options={$state.selectOptions}
        onChange={(value) => {
          $setState({
            oSelect: value,
          });
          run();
        }}
        text={$state.selectOptions.find((rs) => rs.value === $state.oSelect)?.text || ''}
      />
      <FComponentsLib.FInput.FSearch
        value={$state.oInput}
        onChange={(value) => {
          $setState({
            oInput: value,
          });
          run();
        }}
      />
    </div>
    <div style={{ height: 30 }} />

    {
      $listState === 'loading' && (<FLoadingTip height={600} />)
    }

    {
      $listState === 'noData' && (<FNoDataTip height={600} tipText={'无数据'} />)
    }

    {
      $listState === 'noSearchResult' && (<FNoDataTip height={600} tipText={'无搜索结果'} />)
    }

    {
      $listState === 'loaded' && (<>
        <div className={styles.list}>
          {
            $state.objectList.map((o) => {
              return (<div
                key={o.objectId}
                className={styles.itemCard}
                onMouseEnter={() => {
                  if (selectedObjectIDs.includes(o.objectId)) {
                    set$showDeleteResourceID(o.objectId);
                  }
                }}
                onMouseLeave={() => {
                  set$showDeleteResourceID('');
                }}
              >
                <div
                  className={styles.item}
                  onClick={() => {
                    if (!selectedObjectIDs.includes(o.objectId)) {
                      onSelect?.({ id: o.objectId, name: `${o.bucketName}/${o.objectName}` });
                    }
                  }}
                >
                  <div className={styles.content}>
                    <div>
                      <FComponentsLib.FContentText
                        text={`${o.bucketName}/${o.objectName}`}
                        type={'highlight'}
                        style={{
                          maxWidth: 350,
                        }}
                        singleRow
                      />
                      <div style={{ height: 10 }} />
                      <div className={styles.info}>
                        {/*<img className={styles.avatar} src={i.avatar} alt={''} />*/}
                        <FComponentsLib.FContentText
                          text={`更新时间 ${o.updateDate}`}
                          type={'additional2'}
                          style={{
                            maxWidth: 340,
                          }}
                          singleRow
                        />
                      </div>
                    </div>
                  </div>

                  {
                    selectedObjectIDs.includes(o.objectId) && (<label className={styles.selectedLabel}>
                      <FIcons.FCheck style={{ fontSize: 14, color: '#2784FF' }} />
                      <span>已添加</span>
                    </label>)
                  }

                  {/*{*/}
                  {/*  (!selectedObjectIDs.includes(o.objectId))*/}
                  {/*    ? (<FComponentsLib.FRectBtn*/}
                  {/*      type='secondary'*/}
                  {/*      size='small'*/}
                  {/*      onClick={() => {*/}
                  {/*        onSelect && onSelect({ id: o.objectId, name: `${o.bucketName}/${o.objectName}` });*/}
                  {/*      }}*/}
                  {/*      // disabled={!i.latestVersion}*/}
                  {/*    >选择</FComponentsLib.FRectBtn>)*/}
                  {/*    : (<FComponentsLib.FRectBtn*/}
                  {/*      type='danger2'*/}
                  {/*      size='small'*/}
                  {/*      onClick={() => {*/}
                  {/*        onDelete && onDelete({ id: o.objectId, name: `${o.bucketName}/${o.objectName}` });*/}
                  {/*      }}*/}
                  {/*      // disabled={disabledIDsOrNames?.includes(i.title) || disabledIDsOrNames?.includes(i.id)}*/}
                  {/*    >移除</FComponentsLib.FRectBtn>)*/}
                  {/*}*/}
                </div>

                {
                  $showDeleteResourceID === o.objectId && (
                    <div
                      className={styles.deleteButton}
                      onClick={() => {
                        onDelete?.({ id: o.objectId, name: `${o.bucketName}/${o.objectName}` });
                        set$showDeleteResourceID('');
                      }}>
                      移除
                    </div>)
                }
              </div>);
            })
          }
        </div>

        <FListFooter
          state={$listMore}
          onClickLoadMore={() => {
            fetchObjects(false);
          }}
        />
      </>)
    }


    {/*<FResourceList*/}
    {/*  disabledIDsOrNames={disabledIDsOrNames}*/}
    {/*  showRemoveIDsOrNames={showRemoveIDsOrNames}*/}
    {/*  resourceObjects={$state.objectList.map<FResourceListProps['resourceObjects'][number]>((o) => ({*/}
    {/*    id: o.objectId,*/}
    {/*    resourceType: o.resourceType,*/}
    {/*    status: 1,*/}
    {/*    time: o.updateDate,*/}
    {/*    title: `${o.bucketName}/${o.objectName}`,*/}
    {/*    latestVersion: '0.0.0',*/}
    {/*  }))}*/}
    {/*  loading={$state.oTotal === -1}*/}
    {/*  stillMore={$state.oTotal > $state.objectList.length}*/}
    {/*  onSelect={(value) => {*/}
    {/*    onSelect && onSelect({ id: value.id, name: value.title });*/}
    {/*  }}*/}
    {/*  onDelete={(value) => {*/}
    {/*    onDelete && onDelete({ id: value.id, name: value.title });*/}
    {/*  }}*/}
    {/*  onLoadMord={() => {*/}
    {/*    fetchObjects(false);*/}
    {/*  }}*/}
    {/*/>*/}
  </>);
}

export default FObjectSelector;
